import { API_GATEWAY } from '../consts/api';
import { ENVIRONMENTS_NAMES } from '../consts/environments';
import { DOMAINS } from '../consts/domains';

export const getSubdomain = (url) => {
  let domain = url;
  if (url.includes('://')) {
    domain = url.split('://')[1];
  }
  let subdomain = domain.split('.')[0].toUpperCase();

  if (subdomain === 'WWW') {
    subdomain = domain.split('.')[1].toUpperCase();
  }

  if (subdomain === 'CREDIT24' || subdomain === 'CREDITEA') {
    return 'NO_SUBDOMAIN';
  }
  return subdomain;
};

export const determineEnv = () => {
  const hostname = window.location.hostname;
  const subdomain = getSubdomain(hostname);

  if (subdomain === 'NO_SUBDOMAIN') {
    return 'PRODUCTION';
  }
  return subdomain;
};

export const getApiGatewayDomain = () => {
  const { hostname } = window.location;
  const subdomain = getSubdomain(hostname);
  const AIO_ENV = process.env.AIO_ENV || 'st08';

  const isProd = subdomain === DOMAINS.NO_SUBDOMAIN;
  const isUat = subdomain === DOMAINS.UAT;
  const isUatAioEnv = AIO_ENV === DOMAINS.UAT;
  const isLocalhost = subdomain === DOMAINS.LOCALHOST;

  if (isProd) {
    return API_GATEWAY.DOMAIN(ENVIRONMENTS_NAMES.PROD);
  }

  if (isUat) {
    return API_GATEWAY.DOMAIN(ENVIRONMENTS_NAMES.UAT);
  }

  if (isLocalhost) {
    if (isUatAioEnv) {
      return API_GATEWAY.DOMAIN(ENVIRONMENTS_NAMES.UAT);
    }
    return API_GATEWAY.DOMAIN(AIO_ENV);
  }
  return API_GATEWAY.DOMAIN(subdomain);
};
